import React from 'react';
import { AppSetting } from 'dependencies/appsettings';
import { ButtonCallToAction } from 'ui';
import { externalRedirect } from 'app/infrastructure/platform';
import styles from './user-profile-heading.scss';

interface UserProfileHeadingProps {
  className?: string;
  title: string;
  showVeracityProfileLink?: boolean;
  veracityProfileLinkTitle?: string;
}

export const UserProfileHeading = ({ className, title, showVeracityProfileLink, veracityProfileLinkTitle }: UserProfileHeadingProps) => {

  const isExternalUserHandlingEnabled = (AppSetting.ExternalUserHandlingEnabled || {} as any);
  const viewUserLink = (AppSetting.ViewUserLink || {} as any);
  const redirectToVeracityProfile = () => externalRedirect(viewUserLink);

  return (<>
    <div className={`${styles.headerWrapper} ${className} header-panel`}>
      <div className={`main-grid ${isExternalUserHandlingEnabled ? styles.flexContainer : ''}`}>
        <div className={styles.headerPanel}>
          <h2>{title}</h2>
        </div>
        {
          showVeracityProfileLink && isExternalUserHandlingEnabled && !!viewUserLink && <ButtonCallToAction
            id="veracity-profile-link"
            onClick={redirectToVeracityProfile}
            disabled={false}>
            {veracityProfileLinkTitle}
          </ButtonCallToAction>
        }
      </div>
    </div>
  </>);
};
